import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { useApp } from '../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import SearchConsole from '../../components_shared/SearchConsole';
import '../../styles/dashboard.css';

export default function AppLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    const stored = localStorage.getItem('eduss_sidebar_open');
    return stored === null ? true : stored === 'true';
  });
  const { user, logout } = useApp();
  const navigate = useNavigate();

  const handleMenuClick = () => setSidebarOpen(o => {
    const v = !o;
    localStorage.setItem('eduss_sidebar_open', String(v));
    return v;
  });

  const handleLogout = () => {
    logout && logout();
  };

  const handleNavigate = (page, tab) => {
    if (page === 'admin-management' && tab === 'profile') {
      navigate('/profile');
    }
  };

  const sidebarWidth = sidebarOpen ? 260 : 72;

  return (
    <div
      className={`eduss-app-layout${sidebarOpen ? ' sidebar-open' : ' sidebar-closed'}`}
      style={{ display: 'flex', minHeight: '100vh', background: '#f4f7f9' }}
    >
      <SearchConsole />
      <Sidebar open={sidebarOpen} />

      <div
        className="eduss-main-content"
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          marginLeft: sidebarWidth,
          transition: 'margin-left 0.3s cubic-bezier(0.4,0,0.2,1)',
        }}
      >
        <Topbar
          sidebarOpen={sidebarOpen}
          onMenuClick={handleMenuClick}
          onLogout={handleLogout}
          onNavigate={handleNavigate}
          user={user}
        />

        {/* 64px offset for fixed topbar */}
        <main
          className="eduss-content-area"
          style={{
            flex: 1,
            padding: '16px 18px',
            marginTop: 64,
            minHeight: 0,
          }}
        >
          {children}
        </main>
      </div>
    </div>
  );
}

AppLayout.propTypes = { children: PropTypes.node };
